/* eslint-disable */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ECharts from 'echarts-for-react';
import { Box, Tab, Table, TableBody, TableCell, TableContainer, TableRow, Tabs } from "@mui/material";
import { getdDiagnosisResultChainGraphDayByQuery } from "components/axios/equipmentAlertsAxios";
import MainCard from "components/MainCard";
import EquipmentPartSensorsGraphsLayer from "components/layer/EquipmentPartSensorsGraphsLayer";
import dayjs from "dayjs";

const chartDataInit = {
    // darkmode:true,
    textStyle : {
        color : '#ffffff'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
        data : [],
        left : 'center',
        top: 0,
        backgroundColor : '#2f2f2f',
        textStyle: {
            color: '#ffffff'
        }
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: [ ]
    },
    yAxis: {
        type: 'value'
    },
    series: [ ]
}

function EquipmentPartChainGraphs({equipment, equipmentPartId, diagnosisResultChain, type="none"}) {
    const { t } = useTranslation();
    const [lengthOptions, setLengthOptions] = useState({chartDataInit});
    const [elongOptions, setElongOptions] = useState({chartDataInit});

    useEffect(()=>{
        if(equipmentPartId) {
            let graphParam = {"equipmentPart.id":equipmentPartId};
            setLengthOptions(null)
            setElongOptions(null)
            getdDiagnosisResultChainGraphDayByQuery(graphParam).then((data)=>{
                if (data && data._embedded) {
                    let list = data._embedded.groupByDailyDiagnosisResultChains;
                    list.sort(function(a,b) {
                        const upperCaseA = a.ymd.toUpperCase();
                        const upperCaseB = b.ymd.toUpperCase();
                        if (upperCaseA > upperCaseB) return 1;
                        if (upperCaseA < upperCaseB) return -1;
                        if (upperCaseA === upperCaseB) return 0;
                    });
                    let optionsCopy = {...chartDataInit};
                    let chartDataCopy1 = JSON.parse(JSON.stringify(optionsCopy));
                    let chartDataCopy2 = JSON.parse(JSON.stringify(optionsCopy));
                    
                    let lengths = [];
                    let elongs = [];
                    list.map(function(item, i) {
                        chartDataCopy1.xAxis.data.push(item.ymd);
                        chartDataCopy2.xAxis.data.push(item.ymd);
                        lengths.push(item.length.toFixed(2));
                        elongs.push(item.elongation.toFixed(2));
                    });
                    chartDataCopy1.series.push({name:t('message.common.subtitle.length'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : lengths});
                    chartDataCopy2.series.push({name:t('message.common.subtitle.elongation'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : elongs});
                    chartDataCopy1.legend.data.push(t('message.common.subtitle.length'));
                    chartDataCopy2.legend.data.push(t('message.common.subtitle.elongation'));
                    setLengthOptions(chartDataCopy1)
                    setElongOptions(chartDataCopy2)
                } else {
                    setLengthOptions(null)
                    setElongOptions(null)
                }
            })
        }
    },[equipmentPartId]);

    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    if (lengthOptions && elongOptions) {
        let className = '';
        if (type === 'popup') className='pop_tr';
        return (
        <>
            {diagnosisResultChain && 
            <TableContainer>
                <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width">
                    <TableBody>
                        <TableRow className={className}>
                            <TableCell className="th" align="center">{t('message.common.subtitle.diagnosis.date')}</TableCell>
                            <TableCell align="center">{diagnosisResultChain.analysis_at && dayjs(diagnosisResultChain.analysis_at).format("YYYY-MM-DD")}</TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.diagnosis.result')}</TableCell>
                            <TableCell align="center" colSpan={3}>{`${t('message.common.subtitle.length')} : ${diagnosisResultChain.length.toFixed(2)}, ${t('message.common.subtitle.elongation')} : ${diagnosisResultChain.elongation.toFixed(2)}`}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            }
            <div className="row">
                <div className="mixed-chart">
                    <Box>
                        <Tabs value={value} onChange={handleChange} style={{paddingTop:"10px", paddingLeft:"10px"}} sx={{ ".Mui-selected":{bgcolor:"#0a2e60"} }}>
                            {/* {lengthOptions && <Tab value={0} label={t('message.common.chip.length.trend.graph')} className="graphTab" />}
                            {elongOptions && <Tab value={1} label={t('message.common.chip.elongation.trend.graph')} className="graphTab" />} */}

                            {lengthOptions && <Tab value={0} label={
                                <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                                {t('message.common.chip.length.trend.graph')}
                                &nbsp;&nbsp;
                                <EquipmentPartSensorsGraphsLayer equipment={equipment} sensorPosition={null} equipmentPartId={equipmentPartId} 
                                    equipmentPartPosition={null} equipmentPartName={null} type="S2" />
                                </Box>
                                } className="graphTab" />}
                            {elongOptions && <Tab value={1} label={
                                <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                                {t('message.common.chip.elongation.trend.graph')}
                                &nbsp;&nbsp;
                                <EquipmentPartSensorsGraphsLayer equipment={equipment} sensorPosition={null} equipmentPartId={equipmentPartId} 
                                    equipmentPartPosition={null} equipmentPartName={null} type="S3" />
                                </Box>
                                } className="graphTab" />}

                            
                        </Tabs>
                        <Box mt={2}>
                            {value === 0 && lengthOptions &&
                                <MainCard content={false}>
                                    <ECharts
                                      option={lengthOptions}
                                      opts={{ renderer: 'svg', height: '300px' }}
                                      />
                                </MainCard>
                            }
                            {value === 1 && elongOptions &&
                                <MainCard content={false}>
                                    <ECharts
                                    option={elongOptions}
                                    opts={{ renderer: 'svg', height: '300px' }}
                                    />
                                </MainCard>
                            }
                        </Box>
                    </Box>
                </div>
            </div>
            <div className="divide" />
        </>
        )
    }
}

export default EquipmentPartChainGraphs;